export interface IDrawerActiveTab {
  planDay: number;
  notification: number;
}

export const DRAWER_ACTIVE_TAB = {
    planDay: 0,
    notification: 1,
};
